import { InfoCircleOutlined } from '@ant-design/icons'
import { Popover, Typography } from 'antd'
import { CitedNote } from 'features/indicationTriage/cards/ffsCalc/ffsResultPublish/ffsClassificationContent'
import { FC } from 'react'
import styled from 'styled-components'

const HelpBody = styled.div`
  max-width: 22rem;
`
const Summary = styled(Typography.Paragraph)`
  margin-bottom: 0.5rem !important;
  font-size: 0.8125rem;
`
const Citation = styled(Typography.Text)`
  font-size: 0.75rem;
`
const HelpIcon = styled(InfoCircleOutlined)`
  color: ${({ theme }) => theme.forecast?.activeText ?? '#1677ff'};
  cursor: help;
  margin-left: 0.25rem;
`

/**
 * An info icon that reveals a cited explanation (summary + the FFS citation)
 * on hover/click. The FFS pre-planning counterpart to the min-thickness step's
 * label tooltips; kept inside the feature (rather than importing the
 * `src/pages/**` `InfoToolTip`) to avoid a page→feature dependency.
 */
export const CitedHelp: FC<{ note: CitedNote }> = ({ note }) => (
  <Popover
    content={
      <HelpBody>
        <Summary>{note.summary}</Summary>
        <Citation type='secondary'>Reference: {note.citation}</Citation>
      </HelpBody>
    }>
    <HelpIcon />
  </Popover>
)
